import { PRODUCTION, DEVELOPMENT, API_DEV_URL, CLASSIFIER_API_URL } from "./const";
import { isEmpty } from "lodash";

export function baseUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const API_URL = !!import.meta.env.VITE_API_URL && import.meta.env.VITE_API_URL !== "" ? import.meta.env.VITE_API_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return API_DEV_URL;
      case PRODUCTION:
        return API_URL;
      default:
        return API_DEV_URL;
    }
  } else {
    return API_DEV_URL;
  }
}

export const getApiUrl = (path) => {
  return `${baseUrl()}/${path}`;
};

function classifierApiUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const API_URL = !!import.meta.env.VITE_CLASSIFIER_API_URL && import.meta.env.VITE_CLASSIFIER_API_URL !== "" ? import.meta.env.VITE_CLASSIFIER_API_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return CLASSIFIER_API_URL;
      case PRODUCTION:
        return API_URL;
      default:
        return CLASSIFIER_API_URL;
    }
  } else {
    return CLASSIFIER_API_URL;
  }
}

export const getClassifierApiUrl = (path) => {
  return `${classifierApiUrl()}/${path}`;
};
